import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from './../shared/shared.module';
import { FooterSidebarComponent } from './footer-sidebar/footer-sidebar.component';
import { FooterComponent } from './footer/footer.component';
import { GlitterSellPopupComponent } from './navbar/glitter-sell-popup/glitter-sell-popup.component';
import { NavbarComponent } from './navbar/navbar.component';

@NgModule({
  imports: [SharedModule, RouterModule],
  declarations: [NavbarComponent, FooterComponent, FooterSidebarComponent, GlitterSellPopupComponent],
  exports: [NavbarComponent, FooterComponent, FooterSidebarComponent, GlitterSellPopupComponent]
})
export class LayoutModule {}
